import { render, staticRenderFns } from "./TypeConfigCrudListView.vue?vue&type=template&id=4af49a95"
import script from "./TypeConfigCrudListView.vue?vue&type=script&lang=js"
export * from "./TypeConfigCrudListView.vue?vue&type=script&lang=js"
import style0 from "./TypeConfigCrudListView.vue?vue&type=style&index=0&id=4af49a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports